<div class="confirm-dialog">
  <div class="confirm-dialog__header">
    <h1 class="confirm-dialog__title">
      {{ action ? capitalizeFirst(action) : 'Are you sure you want to discard your changes?' }}
    </h1>
    <button class="dialog-close" (click)="dialogRef.close()" type="button" aria-label="Close dialog">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>
  <div class="confirm-dialog__content">
    {{ !message && action ? setAction() : message }}
  </div>
  <div class="confirm-dialog__actions">
    <button class="cancel-button" (click)="dialogRef.close()">{{ negative }}</button>
    <button class="confirm-button" (click)="dialogRef.close(true)">{{ positive }}</button>
    @if (removeFromAllStatements) {
    <button class="confirm-button" (click)="dialogRef.close(removeFromAllCloseValue)">{{ removeFromAllStatements
      }}</button>
    }
  </div>
</div>